import isArray from 'lodash/isArray';

// If a ['step', ['zoom'], ...] expression is used in a Mapbox stylesheet, it must be the top level
// expression. Consequently, if we want to transform that expression (such as by multipling an
// opacity value) we must not do that at the top level.

export default function transformMapboxStepZoomExpression(
    root: mapboxgl.Expression,
    transformExpression: (input: mapboxgl.Expression) => mapboxgl.Expression
): mapboxgl.Expression {
    if (root[0] === 'step' && isArray(root[1]) && root[1][0] === 'zoom') {
        return root.map((leaf, index) => {
            if (index === 0 || index % 2 === 1) return leaf;
            else return transformExpression(leaf);
        }) as mapboxgl.Expression;
    } else {
        return transformExpression(root);
    }
}
